/**
 * loại chứng từ cho enum trong form tìm kiếm chứng từ
 */
export default {
  BUTransfer: 56, // Chuyển khoản kho bạc
  BUTransferDeposit: 561, // Chuyển khoản kho bạc vào TK tiền gửi
  BUTransferPurchase: 57, //  Chuyển khoản kho bạc mua vật tư hàng hóa
  BUTransferVendorPayment: 59, // Chuyển khoản kho bạc trả nhà cung cấp
  BUTransferSalary: 60, //Chuyển khoản kho bạc trả lương
  BUTransferInsurrance: 62, //Chuyển khoản kho bạc thanh toán bảo hiểm
  BUTransferFixedAsset: 58, //Chuyển khoản kho bạc mua tài sản cố định
  BUTreasuryFundTransferSalary: 564, //Chuyển khoản lương
  BUTreasuryFundTransferInsurancePayment: 565, // Chuyển khoản thanh toán bảo hiểm
  BUOpeningCommitment: 606, // Số dư ban đầu cam kết chi
  BUPlanWithdrawDeposit: 562, // Rút dự toán tiền gửi
  BUPlanWithdrawCash: 54, // Rút dự toán tiền mặt
  BUPlanWithdrawTransfer: 55, // Rút dự toán chuyển khoản
  BUPlanWithdrawSalaryTransfer: 563, // Rút dự toán chuyển khoản lương, bảo hiểm
  BUPlanReceipt: 51, //Nhận dự toán đầu năm
  BUPlanSupplement: 52, //Nhận dự toán bổ sung
  BUPlanCancel: 69, // Hủy dự toán,
  BUPlanAdjustment: 53, //Điều chỉnh dự toán
  BUVoucherListPlanned: 63, // Bảng kê chứng từ thanh toán đã cấp dự toán
  BUVoucherListNotPlanned: 64, // Bảng kê chứng từ thanh toán chưa cấp dự toán
  BUVoucherListReceipExpense: 65, // Bảng kê chứng từ thanh toán ghi thu - ghi chi
  BUVoucherListOther: 66, // Bảng kê chứng từ khác
  BUVoucherListRealExpense: 70, // Bảng kê chứng từ thanh toán thực chi
  BUExpenseWithdrawAdjustment: 652, // Điều chỉnh tạm ứng
  BURealExpenseAdjustment: 654, //Điều chỉnh thực chi
  BUBudgetReserve: 73, //Dự toán giữ lại
  BUCommitmentRequest: 71, // Đề nghị cam kết chi
  BUCommitmentAdjustment: 72, // Điều chỉnh cam kết chi

  CAReceiptSale: 102, // Phiếu thu bán hàng
  CAReceipt: 101, // Phiếu thu thông thường
  CAReceiptWithdraw: 114, //Phiếu thu rút tiền gửi ngân hàng, kho bạc
  CAReceiptPlanWithdraw: 105, // Phiếu thu rút dự toán nhập quỹ

  CAPaymentPurchase: 107, // Phiếu chi mua Vật tư, hàng hóa
  CAPaymentVendor: 109, // Phiếu chi trả nhà cung cấp
  CAPaymentSalary: 110, //Phiếu chi trả lương
  CAPayment: 106, //Phiếu chi thông thường
  CAPaymentDeposit: 113, // Phiếu chi nộp vào ngân hàng, kho bạc
  CAPaymentFixedAsset: 108, //Phiếu chi mua TSCĐ
  CAReceiptCustomer: 104, //Phiếu thu tiền khách hàng
  CAReceiptFixedAsset: 103, //Phiếu thu bán TSCĐ

  // SUTransfer: 207, // Điều chuyển CCDC
  SUIncrement: 205, // Ghi tăng CCDC
  SUDecrement: 206, // Ghi giảm CCDC

  SAReturn: 352, //Hàng bán trả lại
  SAInvoice: 351, //Bán hàng chưa thu tiền

  INTransfer: 203, // Chuyển kho
  INAdjustment: 204, // Điều chỉnh tồn kho
  INOutward: 202, // Xuất kho
  INInward: 201, // Nhập kho

  BADeposit: 153, // Thu tiền gửi
  BATransferDeposit: 151, //Tiền đang chuyển đến
  BATransferWithdraw: 152, //Tiền đang chuyển đi
  BADepositSale: 154, //Thu tiền gửi từ bán hàng
  BADepositCustomer: 156, // Thu tiền gửi từ khách hàng
  BAWithdrawVendor: 160, // Chi tiền gửi trả nhà cung cấp
  BAWithDrawSalary: 163, // Chi tiền gửi trả lương
  BAWithDrawFixedAsset: 159, // Chi tiền gửi mua tài sản cố định
  BABankTransfer: 162, // Chuyển tiền nội bộ
  BAWithdrawPurchase: 158, // Chi tiền gửi mua Vật tư, hàng hóa
  BAWithDraw: 157, // Chi tiền gửi

  GLGeneralVoucher: 401, // Chứng từ nghiệp vụ khác
  GLEndYearTransfer: 402, //Kết chuyển số dư cuối năm
  GLBeginningYearTransfer: 403, //Quyết toán số dư đầu năm
  GLProfitLossTransfer: 404, // Xác định kết quả hoạt động
  GLPayrollExpense: 405, //Hạch toán chi phí lương
  GLProvisionalTaxInComeEnterprise: 420, // Tạm tính thuế thu nhập doanh nghiệp
  GLFinalTaxInComeEnterprise: 421, //Quyết toán thuế thu nhập doanh nghiệp

  INInwardFromINAdjustment: 211, // nhập kho từ điều chỉnh tồn kho
  INInwardFromINAdjustmentChangeAmount: 213, // nhập kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)
  INOutwardFromINAdjustment: 212, // xuất kho từ điều chỉnh tồn kho
  INOutwardFromINAdjustmentChangeAmount: 214, // xuất kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)

  FAIncrement: 252, // Phiếu ghi tăng TSCĐ
  FADecrement: 253, // Phiếu ghi giảm TSCĐ
  FAAdjustment: 254, // Đánh giá lại TSCĐ
  FADepreciation: 255, // Tính hao mòn TSCĐ
  FADevaluation: 419, // Tính khấu hao TSCĐ
  FAPurchaseInvoice: 251, // Mua Tài sản cố định chưa thanh toán (Hóa đơn mua TSCĐ)
  // FATransfer: 257, //Điều chuyển tài sản cố định

  FAVoucherDepreciation: 413, // Lấy hao mòn tự nhiên TSCĐ từ QLTS.VN
  FAVoucherIncreament: 410, // Ghi tăng TSCĐ từ QLTS.VN
  FAVoucherAdjustment: 411, // Đánh giá lại TSCĐ từ QLTS.VN
  FAVoucherDepreciate: 412, // Lấy khấu hao TSCĐ từ QLTS.VN
  FAVoucherDecrement: 414, // Ghi giảm TSCĐ từ QLTS.VN  \

  PUInvoice: 301, // Mua hàng chưa thanh toán (Hóa đơn mua hàng)
  FASaleInvoice: 256, // Hóa đơn bán tài sản cố định (Bán tài sản cố định chưa thu tiền)
  BADepositFixedAsset: 155, //Thu tiền gửi từ Bán tài sản cố định
};
